<template>
    <section>
      <h4 class="form-card-header">{{ $t('registration.employment') }}</h4>
      <div class="form-card-form">
        <div>
          <label for="pi_occupation">{{ $t('registration.occupation') }}:<span class="text-danger">*</span></label>
          <select id="pi_occupation"
                  name="occupation"
                  v-model="v$.form.occupation.$model"
                  @blur="v$.form.occupation.$touch()"
                  class="form-select dropdown-color">
            <option v-for="item in occupations" :key="item" :value="item">{{ item }}</option>
          </select>
          <div class="error-message" v-show="v$.form.occupation.$errors.length">
            <div v-show="!v$.form.occupation.$errors.required">{{ $t('helper.please-fill') }}</div>
          </div>
        </div>
  
        <div>
          <label for="pi_company_name">{{ $t('registration.company-name') }}:<span class="text-danger">*</span></label>
          <input id="pi_company_name"
                 size="sm"
                 name="company_name"
                 type="text"
                 class="pi-input"
                 v-model="v$.form.companyName.$model"
                 @blur="v$.form.companyName.$touch()" />
          <div class="error-message" v-show="v$.form.companyName.$errors.length">
            <div v-show="!v$.form.companyName.$errors.required">{{$t('helper.name-regex')}}</div>
          </div>
        </div>

        <div>
          <label for="pi_position">{{ $t('registration.position') }}:<span class="text-danger">*</span></label>
          <input id="pi_position"
                 size="sm"
                 name="position"
                 type="text"
                 class="pi-input"
                 v-model="v$.form.position.$model"
                 @blur="v$.form.position.$touch()" />
          <div class="error-message" v-show="v$.form.position.$errors.length">
            <div v-show="!v$.form.position.$errors.required">{{ $t('helper.name-regex') }}</div>
          </div>
        </div>

        <div>
          <label for="pi_company_address">{{ $t('registration.company-address') }}:<span class="text-danger">*</span></label>
          <input id="pi_company_address"
                 size="sm"
                 name="companyaddress"
                 type="text"
                 class="pi-input"
                 v-model="v$.form.companyAddress.$model"
                 @blur="v$.form.companyAddress.$touch()" />
          <div class="error-message" v-show="v$.form.companyAddress.$errors.length">
            <div v-show="!v$.form.companyAddress.$errors.required">{{ $t('helper.please-fill') }}</div>
          </div>
        </div>
  
        <section class="sub-step-buttons-container">
          <ic-button size="tn" type="button" color="grey" @click="previous()" class="d-flex align-items-center mr-3"><i class="sr sr-chevron-left"></i>{{ $t('button.previous') }}</ic-button>
          <ic-button size="tn" type="button" variant="success"  @click="next()" class="d-flex align-items-center ml-3">{{ $t('button.next') }} <i class="sr sr-chevron-right"></i></ic-button>
        </section>
      </div>
    </section>
  </template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, maxLength } from '@vuelidate/validators'
import { nameRegexValidator } from '../../mixins/regex'

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      occupations: ["Банк, санхүү", "Даатгал", "Эрүүл мэнд", "Үл хөдлөх", "Харилцаа, холбоо", "Мэдээлэл, технологи", "Уул, уурхай", "Боловсрол", "Үйлдвэрлэл, худалдаа", "Бусад"],
      form: {
        occupation: null,
        companyName: null,
        position: null,
        companyAddress: null,
      },
    }
  },
  validations() {
    return {
      form: {
        occupation: { required, min: maxLength(100) },
        companyName: { required, max: maxLength(100), nameRegexValidator },
        position: { required, max: maxLength(100), nameRegexValidator },
        companyAddress: { required, min: maxLength(200) },
      }
    }
  },
  mounted() {
    this.fillOldData()
  },
  methods: {
    previous() {
      this.$emit('previous')
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async next() {
      await this.v$.$validate()
      if (!this.v$.$error) {
        this.$emit('next', this.form)
      } else {
        alert(`${ this.$('helper.please-fill-required-fields') }`)
      }
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    fillOldData() {
      if (!window.oldInputs) return;
      if (window.oldInputs['occupation']) {
        this.$set(this.form, 'occupation', window.oldInputs['occupation']);
      }
      if (window.oldInputs['company_name']) {
        this.$set(this.form, 'company_name', window.oldInputs['company_name']);
      }
      if (window.oldInputs['position']) {
        this.$set(this.form, 'position', window.oldInputs['position']);
      }
      if (window.oldInputs['companyaddress']) {
        this.$set(this.form, 'companyaddress', window.oldInputs['companyaddress']);
      }
    }
  },
}
</script>